import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, NavLink, useLocation } from "react-router-dom";
import ApiService from "../../network/ApiService";


function Navbar(props) {
  const [openDropdown, setOpenDropdown] = useState(null); // 'about', 'news', 'eservices', null
  const [messages, setMessages] = useState([]);
  const organizationDetails = props.orgDetail;
  const [language, setLanguage] = useState('en');

  const { fetchMessages } = ApiService();
  const { organizationId } = useSelector((state) => state.organization);
  const location = useLocation();
  const languageStatus = sessionStorage.getItem("language");
  // Refs for dropdowns
  const aboutDropdownRef = useRef(null);
  const newsDropdownRef = useRef(null);
  const eservicesDropdownRef = useRef(null);

  const fetchStaffMessages = async () => {
    try {
      const response = await fetchMessages();
      console.log("Messages fetched:", response.data);
      setMessages(response.data.mapOfIdAndDisplayLabels);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (organizationId) {
      fetchStaffMessages();
    }
  }, [organizationId]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        (aboutDropdownRef.current && aboutDropdownRef.current.contains(e.target)) ||
        (newsDropdownRef.current && newsDropdownRef.current.contains(e.target)) ||
        (eservicesDropdownRef.current && eservicesDropdownRef.current.contains(e.target))
      ) {
        return;
      }
      setOpenDropdown(null);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="tm-header uk-visible@l" uk-header="true">
        <div
          uk-sticky=""
          media="@l"
          cls-active="uk-navbar-sticky"
          sel-target=".uk-navbar-container"
          className="uk-sticky uk-sticky-fixed"
          style={{ position: 'relative' }}
        >
          <div
            className="uk-navbar-container"
            style={{ backgroundColor: '#0f2495', color: 'white' }}
          >
            <div className="uk-container">
              <nav className="uk-navbar" uk-navbar='{"align":"center"}' style={{ position: 'relative' }}>
                <div className="uk-navbar-left">
                  <ul className="uk-navbar-nav" style={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
                    {/* Home */}
                    <li className="menu-item">
                      <NavLink to="/" className="nav-link" style={{ color: 'white', textDecoration: 'none' }}>
                        {languageStatus === 'en' ? 'Home' : `गृहपृष्ठ`}
                      </NavLink>
                    </li>

                    {/* About Us */}
                    <li
                      className="menu-item uk-parent"
                      style={{ position: 'relative', cursor: 'pointer' }}
                      onClick={() => setOpenDropdown(openDropdown === 'about' ? null : 'about')}
                    >
                      <div style={{ color: 'white', display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                        {languageStatus === 'en' ? 'About Us' : `हाम्रो बारेमा`} ▼
                      </div>

                      {openDropdown === 'about' && (
                        <div ref={aboutDropdownRef}>
                          <ul style={dropdownStyle}>
                            <li style={dropdownItemStyle}>
                              <Link to="/about" style={linkStyle}>
                                {languageStatus === 'en' ? 'Office Information' : `संस्थाको जानकारी`}
                              </Link>
                            </li>
                            {Object.keys(messages).length > 0 && Object.keys(messages).map((key) => (
                              <li key={key} style={dropdownItemStyle}>
                                <Link to={`/messages/${key}`} style={linkStyle}>
                                  {languageStatus === 'en' ? messages[key].designation : messages[key].designationNP}
                                  {languageStatus === 'en' ? `'s Speech` : `को मन्तव्य`}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </li>

                    {/* News & Notices */}
                    <li
                      className="menu-item"
                      style={{ position: 'relative', cursor: 'pointer' }}
                      onClick={() => setOpenDropdown(openDropdown === 'news' ? null : 'news')}
                    >
                      <div style={{ color: 'white', display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                        {languageStatus === 'en' ? 'News & Notices' : `सुचना/गतिविधि`} ▼
                      </div>

                      {openDropdown === 'news' && (
                        <div ref={newsDropdownRef}>
                          <ul style={dropdownStyle}>
                            <li style={dropdownItemStyle}>
                              <Link to="/news" style={linkStyle}>
                                {languageStatus === 'en' ? 'News' : `समाचार`}
                              </Link>
                            </li>
                            <li style={dropdownItemStyle}>
                              <Link to="/notices" style={linkStyle}>
                                {languageStatus === 'en' ? 'Notices' : `सुचना/गतिविधि`}
                              </Link>
                            </li>
                          </ul>
                        </div>
                      )}
                    </li>

                    {/* Our Services */}
                    <li className="menu-item">
                      <Link to="/our-services" style={linkStyle}>
                        {languageStatus === 'en' ? 'Our Services' : `हाम्रा सेवाहरू`}
                      </Link>
                    </li>

                    {/* E-Services */}
                    <li
                      className="menu-item"
                      style={{ position: 'relative', cursor: 'pointer' }}
                      onClick={() => setOpenDropdown(openDropdown === 'eservices' ? null : 'eservices')}
                    >
                      <div style={{ color: 'white', display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                        {languageStatus === 'en' ? 'E-Services' : `ई-सर्विसेस`} ▼
                      </div>

                      {openDropdown === 'eservices' && (
                        <div ref={eservicesDropdownRef}>
                          <ul style={dropdownStyle}>
                            <li style={dropdownItemStyle}>
                              <Link to="/outstanding-report" style={linkStyle}>
                                {languageStatus === 'en' ? 'Outstanding Details' : `बक्यौता विवरण`}
                              </Link>
                            </li>
                            <li style={dropdownItemStyle}>
                              <Link to="/complain-service" style={linkStyle}>
                                {languageStatus === 'en' ? 'Complain Register' : `गुनासो सेवा`}
                              </Link>
                            </li>
                            <li style={dropdownItemStyle}>
                              <Link to="/water-schedule" style={linkStyle}>
                                {languageStatus === 'en' ? 'Water Distribution Schedule' : `पानी बितरण तालिका`}
                              </Link>
                            </li>
                            <li style={dropdownItemStyle}>
                              <Link to="/meter-reading-schedule" style={linkStyle}>
                                {languageStatus === 'en' ? 'Meter Reading Schedule' : `रिडिङ्ग तालिका`}
                              </Link>
                            </li>
                          </ul>
                        </div>
                      )}
                    </li>

                    {/* Download */}
                    <li className="menu-item">
                      <Link to="/download" style={linkStyle}>
                        {languageStatus === 'en' ? 'Download' : `डाउनलोड`}
                      </Link>
                    </li>

                    {/* Gallery */}
                    <li className="menu-item">
                      <Link to="/gallery" style={linkStyle}>
                        {languageStatus === 'en' ? 'Photo Gallery' : `फोटो ग्यालरी`}
                      </Link>
                    </li>

                    {/* Members */}
                    <li className="menu-item">
                      <Link to="/team" style={linkStyle}>
                        {languageStatus === 'en' ? 'Members' : `सदस्य`}
                      </Link>
                    </li>

                    {/* Contact */}
                    <li className="menu-item">
                      <Link to="/contact" style={linkStyle}>
                        {languageStatus === 'en' ? 'Contact' : `सम्पर्क`}
                      </Link>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const dropdownStyle = {
  position: 'absolute',
  top: '100%',
  left: 0,
  backgroundColor: '#0f2495',
  color: 'white',
  minWidth: '220px',
  boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
  borderRadius: '4px',
  padding: '0.5rem 0',
  marginTop: '0.25rem',
  zIndex: 100,
  listStyle: 'none',
};

const dropdownItemStyle = {
  padding: '0.5rem 1rem',
  marginBottom: '0.25rem',
};

const linkStyle = {
  color: 'white',
  textDecoration: 'none',
};

export default Navbar;
